import { useParams } from 'react-router-dom';
import { ReviewTabEnum } from 'v2/models';

export default function useGetForReviewTab(): ReviewTabEnum | null {
  const params = useParams<Record<string, string | undefined>>();
  const tab = params['tab'];
  if (tab) {
    if (tab in ReviewTabEnum) {
      return tab as ReviewTabEnum;
    }
  }
  return null;
}
